import React, { useState } from 'react';
import { Users, X, Minimize2, Maximize2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
interface FloatingPersonaSwitcherProps {
  currentPersona?: string;
}
export function FloatingPersonaSwitcher({
  currentPersona
}: FloatingPersonaSwitcherProps) {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [isMinimized, setIsMinimized] = useState(false);
  const personas = [{
    id: 'buyer',
    label: 'Buyer',
    path: '/dashboard',
    color: 'bg-green-100 text-green-800 border-green-200'
  }, {
    id: 'seller',
    label: 'Seller',
    path: '/dashboard/seller',
    color: 'bg-purple-100 text-purple-800 border-purple-200'
  }, {
    id: 'developer',
    label: 'Developer',
    path: '/dashboard/developer',
    color: 'bg-blue-100 text-blue-800 border-blue-200'
  }, {
    id: 'nri',
    label: 'NRI Buyer',
    path: '/dashboard/nri-buyer',
    color: 'bg-purple-100 text-purple-800 border-purple-200'
  }, {
    id: 'authority',
    label: 'Govt Authority',
    path: '/authority',
    color: 'bg-orange-100 text-orange-800 border-orange-200'
  }, {
    id: 'admin',
    label: 'Admin',
    path: '/admin',
    color: 'bg-red-100 text-red-800 border-red-200'
  }];
  const handlePersonaSwitch = (path: string) => {
    navigate(path);
    setIsOpen(false);
  };
  if (isMinimized) {
    return <button onClick={() => setIsMinimized(false)} className="fixed bottom-6 right-6 w-14 h-14 bg-[#1f2933] text-white rounded-full shadow-lg flex items-center justify-center hover:bg-gray-800 z-50 border-2 border-gray-300" aria-label="Open Persona Switcher" data-id="element-235">
        <Users className="w-6 h-6" data-id="element-236" />
      </button>;
  }
  return <div className="fixed bottom-6 right-6 z-50" data-id="element-237">
      {!isOpen ? <button onClick={() => setIsOpen(true)} className="w-14 h-14 bg-[#1f2933] text-white rounded-full shadow-lg flex items-center justify-center hover:bg-gray-800 border-2 border-gray-300" aria-label="Switch Persona" data-id="element-238">
          <Users className="w-6 h-6" data-id="element-239" />
        </button> : <div className="bg-white border-2 border-gray-300 shadow-2xl rounded-lg w-80 overflow-hidden" data-id="element-240">
          {/* Header */}
          <div className="bg-gray-50 border-b border-gray-200 p-4 flex items-center justify-between" data-id="element-241">
            <div className="flex items-center gap-2" data-id="element-242">
              <Users className="w-5 h-5 text-gray-600" data-id="element-243" />
              <h3 className="font-bold text-sm" data-id="element-244">Switch Persona</h3>
            </div>
            <div className="flex items-center gap-2" data-id="element-245">
              <button onClick={() => setIsMinimized(true)} className="text-gray-400 hover:text-gray-600 p-1" aria-label="Minimize" data-id="element-246">
                <Minimize2 className="w-4 h-4" data-id="element-247" />
              </button>
              <button onClick={() => setIsOpen(false)} className="text-gray-400 hover:text-gray-600 p-1" aria-label="Close" data-id="element-248">
                <X className="w-4 h-4" data-id="element-249" />
              </button>
            </div>
          </div>

          {/* Persona List */}
          <div className="p-3 space-y-2 max-h-96 overflow-y-auto" data-id="element-250">
            {personas.map(persona => <button key={persona.id} onClick={() => handlePersonaSwitch(persona.path)} className={`w-full text-left p-3 border rounded hover:shadow-md transition-shadow ${currentPersona === persona.id ? `${persona.color} border-2` : 'bg-white border-gray-200 hover:bg-gray-50'}`} data-id="element-251">
                <div className="font-bold text-sm" data-id="element-252">{persona.label}</div>
                <div className="text-xs text-gray-500 mt-1" data-id="element-253">
                  {persona.id === 'buyer' && 'Browse and purchase plots'}
                  {persona.id === 'seller' && 'List and manage your properties'}
                  {persona.id === 'developer' && 'Manage inventory and leads'}
                  {persona.id === 'nri' && 'NRI-specific services and compliance'}
                  {persona.id === 'authority' && 'Government land auctions'}
                  {persona.id === 'admin' && 'Platform administration'}
                </div>
              </button>)}
          </div>

          {/* Footer */}
          <div className="bg-gray-50 border-t border-gray-200 p-3 text-center" data-id="element-254">
            <p className="text-xs text-gray-500" data-id="element-255">
              Switch between different user roles to explore the platform
            </p>
          </div>
        </div>}
    </div>;
}